/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Module,
    ModuleFromJSON,
    ModuleFromJSONTyped,
    ModuleToJSON,
} from './';

/**
 * 
 * @export
 * @interface WriteOnlyUserRight
 */
export interface WriteOnlyUserRight {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserRight
     */
    id?: string;
    /**
     * 
     * @type {Module}
     * @memberof WriteOnlyUserRight
     */
    module: Module;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyUserRight
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserRight
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserRight
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof WriteOnlyUserRight
     */
    forTrucks?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WriteOnlyUserRight
     */
    forLightVehicles?: boolean;
}

export function WriteOnlyUserRightFromJSON(json: any): WriteOnlyUserRight {
    return WriteOnlyUserRightFromJSONTyped(json, false);
}

export function WriteOnlyUserRightFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyUserRight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'module': ModuleFromJSON(json['module']),
        'number': json['number'],
        'code': json['code'],
        'label': json['label'],
        'forTrucks': !exists(json, 'for_trucks') ? undefined : json['for_trucks'],
        'forLightVehicles': !exists(json, 'for_light_vehicles') ? undefined : json['for_light_vehicles'],
    };
}

export function WriteOnlyUserRightToJSON(value?: WriteOnlyUserRight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'module': ModuleToJSON(value.module),
        'number': value.number,
        'code': value.code,
        'label': value.label,
        'for_trucks': value.forTrucks,
        'for_light_vehicles': value.forLightVehicles,
    };
}


